var $5b7ed47241cec9bc$exports = {};
$5b7ed47241cec9bc$exports = {
    "collapse": `\u{421}\u{432}\u{438}\u{432}\u{430}\u{43D}\u{435}`,
    "expand": `\u{420}\u{430}\u{437}\u{448}\u{438}\u{440}\u{44F}\u{432}\u{430}\u{43D}\u{435}`
};


export {$5b7ed47241cec9bc$exports as default};
//# sourceMappingURL=bg-BG.module.js.map
